import Tippy from "@tippyjs/react";
import TextLimit from "Api/TextLimit";
import React from "react";
import { NavLink, useParams } from "react-router-dom";

export default function NameCell({ row, getValue, table }) {
	const params = useParams();

	const { id, dayId } = params;
	const { memo, firstName, middleName, lastName, adminId, contractId } = row.original;


	const substName =
		window.innerWidth > 1250
			? TextLimit.AfwezigeLimitOptionOne(firstName, middleName, lastName)
			: TextLimit.AfwezigeLimitOptionTwo(firstName, middleName, lastName);

	return (
		<div className="d-flex justify-content-between align-items-center gap-3 w-100">
			<Tippy content={getValue()} placement="bottom" arrow>
				<NavLink to={`/verzoeken/planscreen/${id}/${dayId}/${contractId}/gebruikers/${adminId}`}>
					{substName}
				</NavLink>
			</Tippy>
			{memo && (
				<Tippy content={memo} placement="bottom" arrow>
					<div className="planscreen__cell--memo"></div>
				</Tippy>
			)}
		</div>
	);
}
